module.exports = {"insufficient_coins":"Sem moedas suficientes.","error":"Erro ao processar o pedido.","ordered":"Produto solicitado."};